var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationDesktopLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4786 13.6587C5.36252 -3.23255 30.6573 -3.21305 34.5215 13.6782C36.7887 23.5866 30.5587 31.9737 25.0975 37.162C21.1348 40.946 14.8653 40.946 10.8828 37.162C5.44138 31.9737 -0.78866 23.5671 1.4786 13.6587Z",
    fill: "white",
    stroke: "#0008C3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1512 23.2941C21.5484 23.2941 24.3024 20.5695 24.3024 17.2086C24.3024 13.8476 21.5484 11.123 18.1512 11.123C14.754 11.123 12 13.8476 12 17.2086C12 20.5695 14.754 23.2941 18.1512 23.2941Z",
    stroke: "#0008C3",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDesktopLogo);
export default __webpack_public_path__ + "static/media/LocationDesktopLogo.1105149aee75736620d843fad36f1f7c.svg";
export { ForwardRef as ReactComponent };